import ReactQuill from 'react-quill';
import 'react-quill/dist/quill.bubble.css';
import { Box } from '@mui/material';

const QuillRichTextShower = (props) => {
    const { html, border = 0 } = props;
    return (
        <Box sx={{ display: 'flex', p: 1, border }}>
            <ReactQuill readOnly value={html} theme="bubble" />
        </Box>
    );
};

export default QuillRichTextShower;
